import httpClient from './httpClient';

export default {
  getBusinessWithId: businessUserId => httpClient.get(`api/business/get/${businessUserId}`),
  getBusinessNoId: () => httpClient.get('api/business/get', { cache: false }),
  getBusinessUsers: () => httpClient.get('api/business/users/get', { cache: false }),
  getBusinessHardlinks: () => httpClient.get('api/business/hardlinks'),
  addUserToBusinessAndSendInvitation: payload => httpClient.post('user/invite', payload),
  deleteSelectedBusinessUser: userId => httpClient.delete(`api/business/user/delete/${userId}`),
  getCsRepInfo: crmId => httpClient.get(`api/business/cs_owner/${crmId}`),
  getCCCParams: masterBusinessId => httpClient.get(`ccc/${masterBusinessId}`),
  successfulCardCaptureCallback: (masterBusinessId, paymentMethodId) =>
    httpClient.put('ccc/callback-success', null, { params: { masterBusinessId, paymentMethodId } }),
};
